'use strict';

exports.__esModule = true;
exports.default = {
    el: {
      colorpicker: {
        confirm: 'ตกลง',
        clear: 'ล้างข้อมูล'
      },
      datepicker: {
        now: 'ตอนนี้',
        today: 'วันนี้',
        cancel: 'ยกเลิก',
        clear: 'ล้างข้อมูล',
        confirm: 'ตกลง',
        selectDate: 'เลือกวันที่',
        selectTime: 'เลือกเวลา',
        startDate: 'วันที่เริ่มต้น',
        startTime: 'เวลาเริ่มต้น',
        endDate: 'วันที่สิ้นสุด',
        endTime: 'เวลาสิ้นสุด',
        prevYear: 'Previous Year', // to be translated
        nextYear: 'Next Year', // to be translated
        prevMonth: 'Previous Month', // to be translated
        nextMonth: 'Next Month', // to be translated
        year: 'ปี',
        month1: 'มกราคม',
        month2: 'กุมภาพันธ์',
        month3: 'มีนาคม',
        month4: 'เมษายน',
        month5: 'พฤษภาคม',
        month6: 'มิถุนายน',
        month7: 'กรกฎาคม',
        month8: 'สิงหาคม',
        month9: 'กันยายน',
        month10: 'ตุลาคม',
        month11: 'พฤศจิกายน',
        month12: 'ธันวาคม',
        // week: 'week',
        weeks: {
          sun: 'อา',
          mon: 'จ',
          tue: 'อ',
          wed: 'พ',
          thu: 'พฤ',
          fri: 'ศ',
          sat: 'ส'
        },
        months: {
          jan: 'มกราคม',
          feb: 'กุมภาพันธ์',
          mar: 'มีนาคม',
          apr: 'เมษายน',
          may: 'พฤษภาคม',
          jun: 'มิถุนายน',
          jul: 'กรกฎาคม',
          aug: 'สิงหาคม',
          sep: 'กันยายน',
          oct: 'ตุลาคม',
          nov: 'พฤศจิกายน',
          dec: 'ธันวาคม'
        }
      },
      select: {
        loading: 'กำลังโหลด',
        noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
        noData: 'ไม่พบข้อมูล',
        placeholder: 'เลือก'
      },
      cascader: {
        noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
        loading: 'กำลังโหลด',
        placeholder: 'เลือก',
        noData: 'ไม่พบข้อมูล'
      },
      pagination: {
        goto: 'ไปที่หน้า',
        pagesize: '/หน้า',
        total: 'ทั้งหมด {total} รายการ',
        pageClassifier: ''
      },
      messagebox: {
        title: 'ข้อความ',
        confirm: 'ตกลง',
        cancel: 'ยกเลิก',
        error: 'คุณป้อนข้อมูลไม่ถูกต้อง'
      },
      upload: {
        deleteTip: 'press delete to remove', // to be translated
        delete: 'ลบ',
        preview: 'ตัวอย่าง',
        continue: 'ทำต่อ'
      },
      table: {
        emptyText: 'ไม่พบข้อมูล',
        confirmFilter: 'ยืนยัน',
        resetFilter: 'รีเซ็ต',
        clearFilter: 'ทั้งหมด',
        sumText: 'Sum' // to be translated
      },
      tree: {
        emptyText: 'ไม่พบข้อมูล'
      },
      transfer: {
        noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
        noData: 'ไม่พบข้อมูล',
        titles: ['List 1', 'List 2'], // to be translated
        filterPlaceholder: 'Enter keyword', // to be translated
        noCheckedFormat: '{total} รายการ', // to be translated
        hasCheckedFormat: '{checked}/{total} checked' // to be translated
      },
      image: {
        error: 'FAILED' // to be translated
      },
      pageHeader: {
        title: 'Back' // to be translated
      }
    }
  }